const ShopProductsGrid = function () {
    // Get important elements
	const container = document.querySelector('[data-collection-product-grid]');
    if (!container) {
        console.warn('No [data-collection-product-grid] found for the product grid');
        return;
    }
    const filtersContainer = container.querySelector(
        '[data-collection-product-grid-filters-form]',
    );
    const resultContainer = container.querySelector(
        '[data-collection-product-grid-results]',
    );
    const paginationContainer = container.querySelector('[data-pagination]');
    let sortSelects = container.querySelectorAll('[data-sort-select]');

    /**
     * Performs setup for the product grid
     * firstTime should be false if the grid is being reloaded via ajax
     * @param {boolean} firstTime 
     */
    const init = (firstTime = false) => {
        if (firstTime) {
            initToggleSidebarButton();
        }
        addAllButtons();
        initForm();
        initToggleTags();
        initPagination();
        initSort(firstTime);
    }

    /**
     * Initialize the toggle sidebar button
     */
    const initToggleSidebarButton = () => {
        const toggleSidebarButton = container.querySelector('.btn-toggle-filters');
        if (toggleSidebarButton) {
            const text = toggleSidebarButton.querySelector('.toggle-text')
            const sidebar = container.querySelector('.col-filters');
            toggleSidebarButton.addEventListener('click', () => {
                sidebar.classList.toggle('sidebar-open');
                if (sidebar.classList.contains('sidebar-open')) {
                    text.innerHTML = 'Hide Filters';
                } else {
                    text.innerHTML = 'Show Filters';
                }
            });
        }
    }

    /**
     * initialize the filter form, checkboxes and chip buttons
     */
    const initForm = function () {
        filtersContainer.addEventListener('submit', function (e) {
            e.preventDefault();
            populateGrid();
        });

        filtersContainer.querySelectorAll('.filter-chip button').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                if (e.currentTarget.dataset.filterName === 'all') {
                    filtersContainer.querySelectorAll('input[type="checkbox"]').forEach((input) => {
                        input.checked = false;
                    });
                } else {
                    let inputs = filtersContainer.querySelectorAll(
                        `input[name="${e.currentTarget.dataset.filterName}"][value="${e.currentTarget.dataset.filterValue}"]`,
                    );
                    inputs.forEach((input) => {
                        input.checked = false;
                    })
                }
                populateGrid();
            })
        });

        filtersContainer.querySelectorAll('input').forEach(function (input) {
            input.addEventListener('change', function (e) {
                populateGrid();
            });
        });
    };

    const initAjaxLink = (ele) => {
        if (!ele) return;
        ele.addEventListener('click', (e) => {
            e.preventDefault();
            populateGrid(ele.getAttribute('href'));
        })
    }

    const initPagination = () => {
        const prevButton = paginationContainer.querySelector('.btn-pagination--prev');
        const nextButton = paginationContainer.querySelector('.btn-pagination--next'); 
        initAjaxLink(prevButton);
        initAjaxLink(nextButton);
    }

    /**
     * Initialize the sort select
     */
    const initSort = (firstTime = false) => {
        sortSelects = container.querySelectorAll('[data-sort-select]');
        if (!sortSelects.length) return;

        if (firstTime) {
            sortSelects.forEach((sortSelect) => {
                sortSelect.addEventListener('change', () => {
                    let value = sortSelect.value;
                    sortSelects.forEach((select) => {
                        select.value = value;
                    })
                    populateGrid();
                });
            })
        } else {
            // Apparently the only way to get the sorts to stay in sync and not 
            // add a million event listeners to the other sort select
            const mobileSort = filtersContainer.querySelector('[data-sort-select]');
            mobileSort?.addEventListener('change', () => {
                let value = mobileSort.value;
                sortSelects.forEach((select) => {
                    select.value = value;
                })
                populateGrid();
            });
        }
    }

    /**
     * Init "show more/less tags" buttons
     */
    const initToggleTags = () => {
        const filterGroups = filtersContainer.querySelectorAll('[data-filter-group]');
        filterGroups.forEach((filterGroup) => {
            const toggleTagsButtons = filterGroup.querySelectorAll('[data-toggle-tags]');
            const tags = filterGroup.querySelectorAll('.tag');
            for (const toggleTagsButton of toggleTagsButtons) {
                toggleTagsButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    for (const tag of tags) {
                        tag.classList.toggle('active');
                    }
                });
            }
        })
    }

    /**
     * Get the "all" checkbox filters and add the event listeners
     */
    const addAllButtons = function () {
        const allBtns = container.querySelectorAll('[data-filter-btn-all]');
        allBtns.forEach((btn) => {
            btn.addEventListener('click', function (e) {
                let filterGroup = e.currentTarget.dataset.filterBtnAll;
                filtersContainer
                    .querySelectorAll(
                        `[data-filter-group="${filterGroup}"] input[type="checkbox"]`,
                    )
                    .forEach((input) => {
                        input.checked = false;
                    });
                btn.checked = true;
                populateGrid();
            });
        });
    };

    /**
     * @param {*} url
     * Populate the grid with ajax results from the provided url
     */
    const populateGrid = function (url = false) {
        url = updateUrl(url);
        resultContainer.querySelectorAll('.col').forEach((col) => {
            col.classList.add('skeleton-loader');
        })
        window.scrollTo({
            top: container.offsetTop - 84,
            behavior: 'smooth',
        })
        fetch(url)
            .then((res) => {
                if (!res.ok) return false;
                return res.text();
            })
            .then((text) => {
                if (!text) return;

                let div = document.createElement('div');
                div.innerHTML = text;
                const resResultsContainer = div.querySelector(
                    '[data-collection-product-grid-results]',
                );
                const resFiltersContainer = div.querySelector(
                    '[data-collection-product-grid-filters-form]',
                );
                const resPagination = div.querySelector('[data-pagination]');
                resultContainer.innerHTML = resResultsContainer.innerHTML;
                filtersContainer.innerHTML = resFiltersContainer.innerHTML;
                paginationContainer.innerHTML = resPagination.innerHTML
                init(false);
            });
    };

    /**
     * Get the filter params from the form
     * @returns {string}
     */
    const getFilterParams = function (url = false) {
        let formData = new FormData(filtersContainer);
        if (sortSelects.length > 0) {
            formData.append('sort_by', sortSelects[0].value);
        }
        // since page updates happen when a URL is passed to updateUrl, 
        // this function is only called when the page is reset to 1
        formData.append('page', 1); 
        let search = new URLSearchParams(formData);
        return search.toString();
    };

    /**
     * Update the browser url without reloading the page
     * based on the filter params
     * @param {string} url
     * @returns {string}
     */
    const updateUrl = function (url = false) {
        if (url) {
            let newRelativePathQuery = url;
            history.pushState(null, '', newRelativePathQuery);
        } else {
            const filterParams = getFilterParams(url);
            const baseUrl = container.dataset.url;
            if (baseUrl.includes('?')) {
                url = baseUrl + '&' + filterParams;
            } else {
                url = baseUrl + '?' + filterParams;
            }
            let newRelativePathQuery = window.location.pathname + '?' + filterParams;
            history.pushState(null, '', newRelativePathQuery);
        }
        return url;
    };

    // Initialize the grid
    init(true);
};

export default ShopProductsGrid;